import { Box, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { lightColors } from '../../../packages/uikit/src/theme/colors'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean; $isChartDisplayed: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  position: relative;

  ${({ theme }) => theme.mediaQueries.lg} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'margin: 24px 40px' : 'margin: 0 40px')};
  }

  @media all and (min-width: 1390px){
    ${({ $isChartExpanded, $isChartDisplayed }) => ($isChartExpanded ? 'padding: 0;' : $isChartDisplayed ? 'margin: 0 230px 0 40px;' : '')}
  }
`
export const StyledInputCurrencyGlow = styled(Box)`
  display: block;
  position: absolute;
  width: 100%;
  background: ${({ theme }) => lightColors.gradients.bluePink};
  ${({ theme }) => (theme.isDark ? 'filter: blur(15px);' : 'display: none;')};
  height: 100%;
  border-radius: 12px;
  opacity: 0.3;
`

export const StyledInputCurrencyWrapper = styled(Box)`
  max-width: 100%;
`
